import isWindow from './isWindow';

export function getUrlParamValue(key: string) {
    if (!isWindow()) return null;
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
}
